import { useMemo } from 'react'
import { LocationDTO } from '@sales-center/common'
import { useGetServicesByLocationId } from '@user/store/locations'
import { getServiceLocationTitle } from '@sales-center/common'
import { useOrderedServiceList } from '@user/components/Services/ServiceList/hooks/useOrderedServiceList'

type Props = {
  localMode: boolean
  location: LocationDTO
}

export function useData(props: Props) {
  const { localMode, location } = props

  const services = useGetServicesByLocationId(
    localMode ? location.externalLinkId ?? '' : location.id.toString(),
  )

  const orderedServices = useOrderedServiceList(services)

  const fullName = useMemo(() => {
    return getServiceLocationTitle(location)
  }, [location])

  return { fullName, orderedServices, services } as const
}
